import { Alert, AlertTitle } from '@mui/material';

import { TextContent } from '../structural/text-content';

const PageNotFound = () => {
  return (
    <TextContent>
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        The page does not exist.
      </Alert>
    </TextContent>
  );
};

export default PageNotFound;
